<header mat-dialog-title>
  <div>
    <span *ngIf="ingredient">Modifica Ingrediente: {{ ingredient.name }}</span>
    <span *ngIf="!ingredient">Nuovo Ingrediente</span>
  </div>

  <div class="header-actions" *ngIf="ingredient">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteIngredient()">
        <mat-icon>delete</mat-icon>
        Elimina ingrediente
      </button>
    </mat-menu>
  </div>
</header>

<mat-dialog-content>
  <form [formGroup]="ingredientForm" novalidate>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome Ingrediente</mat-label>
        <input matInput formControlName="name" placeholder="Nome Ingrediente" required>
        <mat-error>Campo obbligatorio</mat-error>
        <!-- <mat-icon matSuffix>shopping_basket</mat-icon> -->
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Prezzo in aggiunta</mat-label>
        <input type="number" matInput formControlName="additionPrice" min="0" step="0.1" placeholder="Prezzo in aggiunta" required>
        <!-- <mat-icon matSuffix>euro_symbol</mat-icon> -->
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Prezzo in differenza</mat-label>
        <input type="number" matInput formControlName="minusPrice" min="0" step="0.1" placeholder="Prezzo in differenza" required>
        <!-- <mat-icon matSuffix>euro_symbol</mat-icon> -->
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Descrizione</mat-label>
        <textarea matInput formControlName="description" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" placeholder="Descrizione"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <button mat-raised-button (click)="revert()" [disabled]="ingredientForm.pristine">
      Reset
    </button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="ingredientForm.pristine || !ingredientForm.valid">
      Salva
    </button>
  </div>
  <div class="right-actions">
    <button mat-raised-button (click)="cancel()">
    Chiudi
  </button>
  </div>
</mat-dialog-actions>

<!-- <div class="footer" *ngIf="loading$ | async">
  <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>
</div> -->
